export type ReferenceType = Record<PropertyKey, any>;

/**
 * Check if a value is an object
 * This includes arrays, but excludes null and functions
 */
export function isObject(value: unknown): value is ReferenceType {
  return value !== null && typeof value === "object";
}
